import type { ReactNode } from "react";
import pxToRem from "../../../utils/pxToRem";
import type { BoxProps } from "../../../Box/Box";
import { Box } from "../../../Box/Box";

import { COUNT_IN_ROW } from "../../constants";
import { useCalendarContext } from "../../context";
import { parseDate } from "../../helpers";
import { Day } from "./Day/Day";

type Props = {
  startDay: number;
  startWeekDay: number;
  daysCount: number;
};

type TdProps = {
  children?: ReactNode;
};

function Td({ children }: TdProps) {
  const filledTdAttributes: BoxProps = {
    border: 1,
    borderColor: "calendarBtnBorderColor",
  };
  const emptyTdAttributes: BoxProps = { "aria-hidden": true };
  return (
    <Box as="td" p={0} size={pxToRem(40)} {...(children ? filledTdAttributes : emptyTdAttributes)}>
      {children}
    </Box>
  );
}

export function Week({ startDay, startWeekDay, daysCount }: Props) {
  const { currentDate } = useCalendarContext();
  const originalDate = new Date(currentDate);
  const firstWeekDay = startDay - startWeekDay;
  const lastWeekDay = startDay + (COUNT_IN_ROW.days - 1 - startWeekDay);
  let days = [];

  for (let currentWeekDay = 0; currentWeekDay < COUNT_IN_ROW.days; currentWeekDay++) {
    const currentDay = startDay + (currentWeekDay - startWeekDay);
    const parsedDate = parseDate(
      new Date(originalDate.getFullYear(), originalDate.getMonth(), currentDay)
    );

    if (currentWeekDay < startWeekDay || currentDay > daysCount) {
      days.push(<Td key={parsedDate} />);
    } else {
      days.push(
        <Td key={parsedDate}>
          <Day
            data-date={`${parsedDate}`}
            currentWeekDay={currentWeekDay}
            firstWeekDay={firstWeekDay}
            lastWeekDay={lastWeekDay}
          />
        </Td>
      );
    }
  }

  return <Box as="tr">{days}</Box>;
}
